// Roles API on the shared apiClient (base URL, auth, error semantics).
// Replaces the role-management half of the retired services/api.ts ApiService.
// `Role` lives here — import it, never redeclare it.
import { deleteRequest, get, postJson, put } from './apiClient';

export interface Role {
  _id: string;
  name: string;
  displayName: string;
  description?: string;
  permissions: any;
  isActive: boolean;
  isSystemRole?: boolean;
  createdAt: string;
}

export interface CreateRoleData {
  name: string;
  displayName: string;
  description?: string;
  permissions: any;
}

type Envelope<T> = { success: boolean; data: T };

export async function getRoles(): Promise<Role[]> {
  const res = await get<Envelope<{ roles: Role[] }>>('/roles');
  return res.data.roles || [];
}

export async function createRole(roleData: CreateRoleData): Promise<Role> {
  const res = await postJson<Envelope<Role>>('/roles', roleData);
  return res.data;
}

export async function updateRole(roleId: string, roleData: Partial<CreateRoleData>): Promise<Role> {
  const res = await put<Envelope<Role>>(`/roles/${roleId}`, roleData);
  return res.data;
}

export async function deleteRole(roleId: string): Promise<void> {
  await deleteRequest(`/roles/${roleId}`);
}
